const Form059TC = {
    stepName: {
        ImportantNotes: "重要提示",
        ApplicationInfo: "學校資料",
        PartA: "締結內地姊妹學校意願表",
        // PartB: "乙部：學校特色",
        PartB: "內地姊妹學校申報表",
        // OtherReason: "附件",
        Confirmation: "確認",
    },
    importantNotesTemp: {
        noteOne: "1. 本電子表格是用於網上提交：",
        noteOne_a: "姊妹學校計劃津貼申請表",
        noteOne_b: "內地姊妹學校申報表",
        noteOne_c: "締結內地姊妹學校意願表",
        noteTwo:
            "2. 在填寫表格前請先參閱教育局通告第9/2025號「全方位學習及姊妹學校津貼」",
        noteTwo_a:
            "https://applications.edb.gov.hk/circular/upload/EDBC/EDBC25009C.pdf",
        noteThree:
            "3. 如電子提交的所有檔案字節總和超出每次上載的10MB限制，提交者應改為採用每次不超出上載限制的分次電子提交方式。",
        noteFour:
            "4. 如申請學校未能按要求提供必須的資料，將可能導致本局未能處理有關申請。",
        noteFive:
            "5. 申請學校須留意在電子表格內提供的姊妹學校計劃負責老師姓名，以便本局人員就津貼事宜聯絡學校。",
        noteSix:
            "6. 如對提交的電子表格有任何查詢，請與教育局學校發展支援組聯絡：",
        noteSix_a: "地址：香港添馬添美道2號政府總部東翼5樓",
        noteSix_b: "電話號碼：	3509 8482",
        noteSix_c: "傳真號碼：	2891 2593",
        noteSix_d: "電郵地址：	sds1@edb.gov.hk",
    },

    importantNotes: {
        p1_1: "個人資料收集聲明",
        p1_2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",

        p1_a: "辦理與聘用有關的事宜；",
        p1_b: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        p1_c: "進行核數工作；",
        p1_d: "進行研究及統計資料，以便規劃教育服務；",
        p1_e: "處理有關教育專業人員發展的事宜；",
        p1_f: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",

        p2: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        p3: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        p4: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },

    label: {
        iamStatement:
            "本人理解申請人和學校批核人員需要擁有「智方便+」帳戶才能處理申請。如果你或學校的批核人員沒有「iAM Smart+」帳戶，請在<a href='https://www.edb.gov.hk/tc/sch-admin/admin/about-sch/sister-sch-scheme/sister-sch-scheme-index.html' style='color:black;' target='_blank'><b><u>此處</b></u></a>下載紙本表格並通過郵寄方式提交。",
        subjectArea: "學科",
        statement: "本人已閱讀、理解及同意上述條款及細則",
        applicationForm: "學校資料",
        partALocationOne: "地域",
        PartBSchoolCharacteristics: "學校特色",
        partCSchoolInformation: "內地姊妹學校資料",

        UploadSigningImage: "UploadSigningImage",
        eSigning: "ESigning",
        iamSmart: "IamSmart",

        rewardOption: {
            schoolInRemoteArea: "山區學校",
            experimentalSchool: "實驗學校",
            foreignLanguageSchool: "外語學校",
            vocationalEducation: "職業教育",
            technologyEducation: "科技教育",
            sports: "體育",
            arts: "藝術",
            subjectArea: "學科（請註明：）",
            others: "其他（請註明：）",
            noApecificChoice: "沒有特定選擇",
        },
        pleaseSpecifycity: "請指定城市",
        pleaseSpecify: "請註明",
        government: "官立",
        aided: "資助",
        dss: "直接資助",
        caput: "按位津貼",
        secondary: "中學",
        primary: "小學",
        special: "特殊學校",
        schoolType: "學校類別：",
        schoolTypeOption: {
            secondary: "中學",
            primary: "小學",
            special: "特殊學校",
        },
        financeType: "資助類別：",
        financeTypeOption: {
            government: "官立",
            aided: "資助",
            dss: "直接資助",
            caput: "按位津貼",
        },
        schoolAddress: "學校地址",
        schoolTel: "學校電話",
        schoolFax: "傳真號碼",
        schoolName: "學校名稱",
        telephone: "學校電話",
        schoolEmailAddress: "學校電郵",
        nameOfPrincipal: "校長姓名",
        teacherName: "校監／校管會主席姓名",
        teacherPost: "網上平臺負責老師職位",
        pleaseSelectAPlan: "請選擇一個計劃",
        GrantfortheSisterSchoolSchemeApplicationForm:
            "本校已參加姊妹學校計劃／及／試辦計劃*",
        SisterSchoolSchemeIndicationofPreferenceforPairingUpwithMainlandSchools:
            "本校仍未參加姊妹學校計劃或試辦計劃，但已與內地學校締結為姊妹學校（請同時提交附件）",
        SisterSchoolSchemeReportingFormonMainlandSisterSchools:
            "本校仍未有姊妹學校，希望透過教育局協調與內地學校締結姊妹學校（請同時提交附件）",
        AreaDetail:
            "# 即廣州市、深圳市、珠海市、佛山市、惠州市、東莞市、中山市、江門市和肇慶市",
        platformName: "姊妹學校／網上平台負責老師姓名",
        teacherNameCharge: "負責老師姓名",
        tooltips:
            "網上平台指由教育局開設的姊妹學校網上平台。教育局會就開啟帳號的事宜稍後聯絡負責老師。(只適用於尚未開啟帳號的學校)",
        partaTooltips: "請在下面的方格內填上1至8的意願",
        platform: "姊妹學校／網上平台負責老師職位：",
        post: "職位",
        platformType: {
            VicePrincipal: "副校長",
            seniorTeacher: "主任",
            teacher: "老師",
            others: "其他",
        },
        // schoolChoiceType: {
        //     schoolChoiceTypeA:
        //         "本校仍未參加姊妹學校計劃或試辦計劃，但已與內地學校締結為姊妹學校（請同時提交附件）。",
        //     schoolChoiceTypeB:
        //         "本校仍未有姊妹學校，希望透過教育局協調與內地學校締結姊妹（請同時提交附件）。",
        // },
        // schoolChoice: {
        //     OurSchoolHasJoined: "本校已參加",
        //     TheSisterSchoolScheme: "姊妹學校計劃",
        //     ThePilotScheme: "試辦計劃",
        // },
        schoolAllChoiceTypeA: {
            schoolChoiceTypeA: "現申請姊妹學校計劃津貼。",
        },

        schoolAllChoiceType: {
            schoolChoiceTypeC: "現提交締結內地姊妹學校意願表。",
            schoolChoiceTypeB: "現提交內地姊妹學校申報表。",
        },

        schoolAllChoice: {
            hasJoined: "本校已參加姊妹學校計劃。",
        },
        schoolAllChoiceTemp: {
            hasNotJoined:
                "本校仍未參加姊妹學校計劃，但已與內地學校締結為姊妹學校。",
            noSisterSchool:
                "本校仍未有姊妹學校，希望透過教育局協調與內地學校締結姊妹學校。",
        },
        schoolAllSelect: {
            schoolChoiceTypeA: "現申請姊妹學校計劃津貼。",
            schoolChoiceTypeC: "現提交締結內地姊妹學校意願表。",
            schoolChoiceTypeB: "現提交內地姊妹學校申報表。",
            hasJoined: "本校已參加姊妹學校計劃。",
            hasNotJoined:
                "本校仍未參加姊妹學校計劃，但已與內地學校締結為姊妹學校。",
            noSisterSchool:
                "本校仍未有姊妹學校，希望透過教育局協調與內地學校締結姊妹學校。",
        },
        management:
            "獲法團校董會／校董會／學校管理委員會（校管會）同意，本校：",
        managementType: {
            yes: "是",
            no: "否",
        },
        platformNameNotes:
            "網上平台指由教育局開設的姊妹學校網上平台。教育局會就開啟帳號的事宜稍後聯絡負責老師。（只適用於尚未開啟帳號的學校）",
        platformNotes:
            "電子平臺是指教育局為姊妹學校設立的電子平臺。教育局將在適當時候聯系主管教師，了解用戶帳戶的創建情況（僅適用於沒有用戶帳戶的學校）。",
        partaNotes:
            "本校希望透過教育局協調，與內地學校締結為姊妹學校，意願如下：",
        partAlabel: {
            pleaseSpecify: "請註明：",
            province: "地區：",
            location: "地點",
            preference: "意願",
            preferenceText: "(請在以下方格填上1-8 的意願, 1為最優先)",
            notes: "即廣州市、深圳市、珠海市、佛山市、惠州市、東莞市、中山市、江門市和肇慶市",
            locationList: {
                sichuanProvince: "四川省",
                hainanProvince: "海南省",
                shanghaiMunicipality: "上海市",
                beijingMunicipality: "北京市",
                fujianProvince: "福建省",
                bayArea: "大灣區",
                citiesInOtherGuangdongProvinc: "廣東省其他地市 (請註明:)",
                otherProvincesOrcities: "其他省市 (請註明:)",
            },
            otherGuangdongCitiesSpecifyOne: "廣東省其他城市 1",
            otherGuangdongCitiesSpecifyTwo: "廣東省其他城市 2",
            otherGuangdongCitiesSpecifyThree: "廣東省其他城市 3",
            otherGuangdongCitiesSpecifyFour: "廣東省其他城市 4",
            otherGuangdongCitiesSpecifyFive: "廣東省其他城市 5",
            otherProvincesOrcitiesSpecifyOne: "其他省市 1",
            otherProvincesOrcitiesSpecifyTwo: "其他省市 2",
            otherProvincesOrcitiesSpecifyThree: "其他省市 3",
            otherProvincesOrcitiesSpecifyFour: "其他省市 4",
            otherProvincesOrcitiesSpecifyFive: "其他省市 5",
            city: "城市",
            provinceOrCity: "省市",
        },
        partBlabel: {
            notes: "本校明白以上意願將作配對時參考之用，最終配對結果須視乎實際情況而定。如有特殊原因未能與教育局安排的學校締結為姊妹學校，本校會以書面形式提出及交代原因。",
            PleaseSpecify: "請註明",
        },
        partClabel: {
            schoolName: "姊妹學校名稱",
            schoolType: "姊妹學校類別：",
            yearOfFormingSisterSchool: "締結年份",
            province: "省",
            city: "市",
            area: "區",
            ourSchool: "我們學校：",
            and: "和：",
            partcJoin: {
                hasJoined: "已參加姊妹學校計劃",
                hasNotJoined: "從未參加姊妹學校計劃",
            },

            partcPair: {
                hasPaired: "已締結內地姊妹學校",
                hasNewlyPaired: "已新增內地姊妹學校",
            },
            supportDocs: "證明文件",
        },
        schoolChoose: {
            locationProvinces: "按本校以下的次序配對",
            AnyProvinces: "由教育局安排的任何省市",
        },
        location: "姊妹學校所屬省市及地區",
        schoolInfomation: "本校已<b>締結／新增</b>的內地姊妹學校資料如下:",
    },
    errorMsg: {
        abOrc: "請選擇a)或b)／c)",
        prefDistinct: "相同意願數字不能出現超過一次",
        emptyPreference: "請輸入您的意願",
        order: "請順序輸入",
        dialogTitle: "失敗",
        dialogContent:
            "當選擇「內地姊妹學校申報表」以外的其他表格時，只有主管人員可以在申請表上簽名。",
        dialogContentForOnlyOption3:
            "當只選擇「內地姊妹學校申報表」表格時，只有校長可以在申請表上簽名。",
    },
};
export default Form059TC;
